import { doGetBoards, doUpdateMedicalBoard } from '@/api/boards';

export default {
  namespaced: true,
  actions: {
    getBoards(_context, payload) {
      return doGetBoards(payload);
    },
    updateMedicalBoard(_context, payload) {
      return doUpdateMedicalBoard(payload);
    },
  },
};
